import api from '@/utils/api';
import {
    GET_LIST_PROCEDURE,
    GET_SPECIFIC_PROCEDURE,
    UPDATE_SPECIFIC_PROCEDURE,
    CREATE_NEW_PROCEDURE,
    REMOVE_PROCEDURE,
    GET_PROCEDURE_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách procedure theo bộ lọc
 */
export const getListProcedure = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/procedures', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_PROCEDURE, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách thủ thuật');
            reject(err);
        });
    });
};

/**
 * Lấy thủ thuật cụ thể theo ID
 */
export const getSpecificProcedure = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/procedures/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_PROCEDURE, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết thủ thuật');
            reject(err);
        });
    });
};

/**
 * Lấy danh sách thủ thuật đang hoạt động
 */
export const getProcedureActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/procedures/active', { params: filter }).then(res => {
            dispatch({ type: GET_PROCEDURE_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách thủ thuật đang hoạt động');
            reject(err);
        });
    });
};

/**
 * Tạo mới thủ thuật
 */
export const createProcedure = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/procedures', data).then(res => {
            dispatch({ type: CREATE_NEW_PROCEDURE, payload: res.data.data });
            NotificationManager.success("Thêm mới thủ thuật thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Thêm mới thủ thuật thất bại');
            reject(err);
        });
    });
};

/**
 * Cập nhật thủ thuật
 */
export const updateProcedure = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/procedures/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_PROCEDURE, payload: res.data.data });
            NotificationManager.success("Cập nhật thủ thuật thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response?.data?.msg || 'Cập nhật thủ thuật thất bại');
            reject(err);
        });
    });
};

/**
 * Xoá một hoặc nhiều thủ thuật
 */
export const removeProcedure = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/procedures`, { data: { ids } }).then(res => {
            dispatch({ type: REMOVE_PROCEDURE, payload: ids });
            NotificationManager.success("Xoá thủ thuật thành công!");
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || 'Xoá thủ thuật thất bại');
            reject(err);
        });
    });
};
